import { Tree } from "@/types/tree";

export type PhantomPage = {
  title: string;
  tree: Tree;
};

class PhantomPageHolder {

  pages: PhantomPage[] = [];

  setPages(pages: PhantomPage[]) {
    this.pages = pages;
  }

  getPage(pageTitle: string) {
    return this.pages.find(page => page.title === pageTitle);
  }

  updatePage(pageTitle: string, newTree: Tree) {
    const pageToUpdate = this.pages.findIndex(page => page.title === pageTitle);
    if (pageToUpdate !== -1) {
      this.pages[pageToUpdate].tree = newTree;
    }
  }
  
}

export const phantomPageHolder = new PhantomPageHolder();


